module.exports = __webpack_public_path__ + "img/1673505277927-2023-01-12 14.33.46.jpg.4ee0954d.webp";